import { debounce } from '@griply/utils';
import { useMemo } from 'react';

export const useDebounce = <Callback extends (...args: any[]) => any>(
  callback: Callback,
  timeout?: number,
) => useMemo(() => debounce(callback, timeout), [callback, timeout]);
